import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle, BookOpen, GraduationCap, Target } from 'lucide-react';
export function SalesCopy() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      margin: '-100px'
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="bg-[#FAFAFA] py-16 md:py-24" data-id="element-77">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        {/* The Problem */}
        <motion.div {...fadeIn} className="prose prose-lg prose-p:text-gray-700 mx-auto mb-16" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8 leading-tight" data-id="element-80">
            ¿Quieres convertirte en RBT... pero sientes que TODO está en inglés
            y nunca vas a entender realmente ABA?
          </h2>

          <p className="text-xl font-medium text-center text-[#7E354D] mb-12" data-id="element-81">
            No eres tú.
          </p>

          <p data-id="element-82">
            El verdadero problema es que nadie te lo ha explicado de una forma
            sencilla... en español.
          </p>
          <p data-id="element-83">
            Si eres hispana y sueñas con convertirte en Registered Behavior
            Technician (RBT), probablemente ya te pasó esto...
          </p>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 my-8" data-id="element-84">
            <ul className="space-y-4 list-none pl-0" data-id="element-85">
              <li className="flex items-start gap-3" data-id="element-86">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-87" />
                <span data-id="element-88">
                  Compraste el curso obligatorio de 40 horas. Pensaste: "Ahora
                  sí voy a entender todo."
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-89">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-90" />
                <span data-id="element-91">
                  Pero mientras avanzabas... Los términos parecían otro idioma.
                  Los ejemplos eran confusos.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-92">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-93" />
                <span data-id="element-94">
                  Terminaste viendo videos en YouTube durante horas, buscando
                  respuestas en grupos de Facebook, traduciendo palabras en
                  Google...
                </span>
              </li>
            </ul>
          </div>

          <p data-id="element-95">Y aun así... Sigues sintiendo miedo de presentar el examen.</p>
          <p className="italic text-gray-500" data-id="element-96">
            Empiezas a preguntarte... "¿Y si simplemente esto no es para mí?"
          </p>
        </motion.div>

        {/* The Solution */}
        <motion.div {...fadeIn} className="mb-16" data-id="element-97">
          <div className="bg-[#7E354D] text-white p-8 md:p-12 rounded-3xl shadow-xl" data-id="element-98">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-99">
              Pero aquí viene la buena noticia...
            </h3>
            <p className="text-lg mb-4" data-id="element-100">
              El problema NO es que ABA sea difícil. Tampoco es que necesites
              hablar inglés perfecto. Y mucho menos que no seas suficientemente
              inteligente.
            </p>
            <p className="text-lg mb-6" data-id="element-101">
              Durante años, la mayoría del material para preparar el examen RBT
              fue creado pensando en personas que dominan el inglés. Eso obliga
              a miles de mujeres hispanas a estudiar traduciendo conceptos en
              lugar de comprenderlos.
            </p>
            <div className="bg-white/10 p-6 rounded-xl border border-white/20" data-id="element-102">
              <p className="font-bold text-xl text-center" data-id="element-103">
                No estudian... Sobreviven.
              </p>
            </div>
            <p className="text-lg mt-6" data-id="element-104">
              Y cuando llega el examen... No fallan por falta de capacidad.
              Fallan porque nadie les enseñó ABA de forma clara.
            </p>
          </div>
        </motion.div>

        {/* The Product Introduction */}
        <motion.div {...fadeIn} className="text-center mb-16" data-id="element-105">
          <p className="text-gray-500 uppercase tracking-widest font-bold mb-4" data-id="element-106">
            Por eso creamos...
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-107">
            RBT en Español
          </h2>
          <h3 className="text-2xl text-[#7E354D] font-bold mb-8" data-id="element-108">
            ABA Sin Enredos™
          </h3>

          <p className="text-xl text-gray-700 mb-8" data-id="element-109">
            Una guía diseñada especialmente para mujeres hispanas que quieren
            aprobar el examen entendiendo realmente los conceptos.
          </p>

          <div className="grid sm:grid-cols-3 gap-6 text-left mb-12" data-id="element-110">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-111">
              <BookOpen className="w-8 h-8 text-[#7E354D] mb-4" data-id="element-112" />
              <p className="font-medium" data-id="element-113">
                Sin páginas llenas de lenguaje técnico.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-114">
              <Target className="w-8 h-8 text-[#7E354D] mb-4" data-id="element-115" />
              <p className="font-medium" data-id="element-116">Sin definiciones imposibles.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-117">
              <GraduationCap className="w-8 h-8 text-[#7E354D] mb-4" data-id="element-118" />
              <p className="font-medium" data-id="element-119">Sin explicaciones complicadas.</p>
            </div>
          </div>

          <p className="text-lg text-gray-700 italic" data-id="element-120">
            "Todo está explicado paso a paso, con un lenguaje sencillo y
            ejemplos fáciles de recordar. Como si una amiga que ya aprobó el
            examen estuviera estudiando contigo."
          </p>
        </motion.div>

        {/* What's Inside */}
        <motion.div {...fadeIn} className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-gray-100 mb-16" data-id="element-121">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-122">
            Dentro aprenderás:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-123">
            {['Qué hace realmente un RBT.', 'Cómo entender el método ABC sin memorizar.', 'Qué son los reforzadores y cuándo utilizarlos.', 'Cómo funcionan los prompts.', 'Las funciones de la conducta explicadas fácil.', 'Ética profesional sin lenguaje complicado.', 'Qué temas aparecen con mayor frecuencia en el examen.', 'Cómo organizar un plan de estudio para sentirte preparada.'].map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-124">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-125" />
                <span className="text-gray-700 font-medium" data-id="element-126">{item}</span>
              </div>)}
          </div>
        </motion.div>

        {/* Bonuses */}
        <motion.div {...fadeIn} className="mb-16" data-id="element-127">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-128">
            Además recibirás GRATIS
          </h3>
          <p className="text-center text-gray-600 mb-10" data-id="element-129">
            tres recursos que normalmente tendrías que comprar por separado.
          </p>

          <div className="space-y-6" data-id="element-130">
            <div className="bg-[#FDF8F5] p-6 md:p-8 rounded-2xl border border-[#F3E8EA] flex flex-col md:flex-row gap-6 items-center" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/38HfodtymivCakFqjHSVQR/ChatGPT_Image_Jun_25,_2026,_02_18_32_AM.png" alt="Checklist" className="w-32 h-32 object-cover rounded-xl shadow-md" data-id="element-132" />
              <div data-id="element-133">
                <span className="bg-[#7E354D] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-134">
                  Bono #1
                </span>
                <h4 className="text-xl font-bold mt-3 mb-2" data-id="element-135">
                  Checklist imprimible
                </h4>
                <p className="text-gray-600" data-id="element-136">
                  Para saber exactamente qué debes dominar antes del examen.
                </p>
              </div>
            </div>

            <div className="bg-[#FDF8F5] p-6 md:p-8 rounded-2xl border border-[#F3E8EA] flex flex-col md:flex-row gap-6 items-center" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/73XJZbNfWnmeKudEuvvkHF/ChatGPT_Image_Jun_25,_2026,_02_42_07_AM.png" alt="Flashcards" className="w-32 h-32 object-cover rounded-xl shadow-md" data-id="element-138" />
              <div data-id="element-139">
                <span className="bg-[#7E354D] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-140">
                  Bono #2
                </span>
                <h4 className="text-xl font-bold mt-3 mb-2" data-id="element-141">
                  300 Flashcards bilingües
                </h4>
                <p className="text-gray-600" data-id="element-142">
                  Aprende los términos más importantes en inglés y entiéndelos
                  en español.
                </p>
              </div>
            </div>

            <div className="bg-[#FDF8F5] p-6 md:p-8 rounded-2xl border border-[#F3E8EA] flex flex-col md:flex-row gap-6 items-center" data-id="element-143">
              <img src="https://cdn.magicpatterns.com/uploads/xp9k8GezAC1MxgNeRA4UbQ/ChatGPT_Image_Jun_25,_2026,_02_38_06_AM.png" alt="Mock Exam" className="w-32 h-32 object-cover rounded-xl shadow-md" data-id="element-144" />
              <div data-id="element-145">
                <span className="bg-[#7E354D] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-146">
                  Bono #3
                </span>
                <h4 className="text-xl font-bold mt-3 mb-2" data-id="element-147">Mock Exam</h4>
                <p className="text-gray-600" data-id="element-148">
                  Un simulacro con preguntas tipo examen y respuestas explicadas
                  paso a paso.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Final CTA Section */}
        <motion.div {...fadeIn} className="text-center" data-id="element-149">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-150">
            Esta guía es para ti si...
          </h3>
          <div className="inline-block text-left bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mb-10" data-id="element-151">
            <ul className="space-y-4" data-id="element-152">
              <li className="flex items-start gap-3" data-id="element-153">
                <CheckCircle2 className="w-5 h-5 text-[#7E354D] flex-shrink-0 mt-0.5" data-id="element-154" />
                <span data-id="element-155">
                  Ya tomaste el curso de 40 horas y sigues confundida.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-156">
                <CheckCircle2 className="w-5 h-5 text-[#7E354D] flex-shrink-0 mt-0.5" data-id="element-157" />
                <span data-id="element-158">El inglés te hace sentir insegura.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-159">
                <CheckCircle2 className="w-5 h-5 text-[#7E354D] flex-shrink-0 mt-0.5" data-id="element-160" />
                <span data-id="element-161">
                  Quieres dejar de perder tiempo viendo videos que se
                  contradicen.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-162">
                <CheckCircle2 className="w-5 h-5 text-[#7E354D] flex-shrink-0 mt-0.5" data-id="element-163" />
                <span data-id="element-164">Buscas un método organizado y sencillo.</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-165">
                <CheckCircle2 className="w-5 h-5 text-[#7E354D] flex-shrink-0 mt-0.5" data-id="element-166" />
                <span data-id="element-167">Quieres estudiar con confianza.</span>
              </li>
            </ul>
          </div>

          <p className="text-xl font-medium text-gray-800 mb-8" data-id="element-168">
            No necesitas ser experta. No necesitas memorizar cientos de
            conceptos. No necesitas un inglés perfecto. Solo necesitas que
            alguien finalmente te explique ABA de la forma correcta.
          </p>

          <a href="https://newdigitalguide.com/cart/42950525616190:1?checkout" className="inline-block text-center bg-[#7E354D] hover:bg-[#5E2538] text-white py-5 px-10 rounded-full font-bold text-xl transition-colors shadow-xl hover:shadow-2xl transform hover:-translate-y-1 w-full md:w-auto" data-id="element-169">
            DESCARGA HOY MISMO
          </a>
          <p className="mt-4 text-sm text-gray-500" data-id="element-170">
            Y empieza a estudiar con la tranquilidad de saber exactamente qué
            debes aprender.
          </p>
        </motion.div>
      </div>
    </div>;
}